import { render, staticRenderFns } from "./SnookerBlockList.vue?vue&type=template&id=0a49a082&"
import script from "./SnookerBlockList.vue?vue&type=script&lang=js&"
export * from "./SnookerBlockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports